const globalNav = {
	headerActiveClass: 'global-header--nav-visible',
	headerLeavingClass: 'global-header--nav-leaving',
	noScrollClass: 'no-scroll',
	mql: window.matchMedia('(min-width: 64em)'),

	elem: {
		$body: document.body,
		$html: document.body.parentNode,
		$globalNav: document.querySelector('#global-navigation'),
		$menuToggle: document.querySelector('#js-menu-toggle'),
		$pageHeader: document.querySelector('#js-global-header'),
	},

	init() {
		if(this.elem.$menuToggle !== null) {
			globalNav.mql.addListener(globalNav.manageMenuState);
			globalNav.manageMenuState(globalNav.mql);
		}
	},

	toggleNav(e) {
		e.preventDefault();
		if(globalNav.elem.$pageHeader.classList.contains(globalNav.headerActiveClass)) {

			globalNav.elem.$pageHeader.classList.add(globalNav.headerLeavingClass);
			globalNav.elem.$pageHeader.addEventListener('transitionend', globalNav.navExitCallback);

		} else {

			let scrollOffset = (0 - window.pageYOffset);

			globalNav.elem.$body.style.top = scrollOffset + 'px';
			globalNav.elem.$html.style.scrollBehavior = 'auto';
			globalNav.elem.$body.classList.add(globalNav.noScrollClass);

			globalNav.elem.$pageHeader.classList.add(globalNav.headerLeavingClass);
			globalNav.elem.$pageHeader.classList.add(globalNav.headerActiveClass);

			globalNav.elem.$globalNav.removeAttribute('hidden');
			globalNav.elem.$menuToggle.setAttribute('aria-expanded', true);

			setTimeout(function(){
				globalNav.elem.$pageHeader.classList.remove(globalNav.headerLeavingClass);
			}, 1);
		}

	},
	navExitCallback() {
		globalNav.elem.$pageHeader.classList.remove(globalNav.headerLeavingClass);
		globalNav.elem.$pageHeader.classList.remove(globalNav.headerActiveClass);

		globalNav.elem.$globalNav.setAttribute('hidden', true);
		globalNav.elem.$menuToggle.setAttribute('aria-expanded', false);

		globalNav.elem.$body.classList.remove(globalNav.noScrollClass);
		globalNav.elem.$pageHeader.removeEventListener('transitionend', globalNav.navExitCallback);

		// window.scroll({ 
		// 	top: (-1 * parseInt(globalNav.elem.$body.style.top.split('px')[0], 10)),
		// 	left: 0,
		// 	behavior: 'auto'
		// });
  	// globalNav.elem.$html.style.removeProperty('scroll-behavior');
  	// globalNav.elem.$body.style.removeProperty('top');
	},
	manageMenuState(e) {
		if (e.matches) {
			globalNav.elem.$globalNav.removeAttribute('hidden');
			globalNav.elem.$menuToggle.setAttribute('aria-expanded', true);
			globalNav.elem.$menuToggle.setAttribute('hidden', true);
			globalNav.elem.$pageHeader.classList.remove(globalNav.headerLeavingClass);
			globalNav.elem.$pageHeader.classList.remove(globalNav.headerActiveClass);
		} else {
			globalNav.elem.$globalNav.setAttribute('hidden', true);
			globalNav.elem.$menuToggle.setAttribute('aria-expanded', false);
			globalNav.elem.$menuToggle.removeAttribute('hidden');
		}
	},
	bindUIActions() {
		if(this.elem.$menuToggle !== null) {
			this.elem.$menuToggle.addEventListener('click', this.toggleNav);

			// Dismiss menus with esc key
			this.elem.$body.addEventListener('keyup', function(e){
				if(e.keyCode === 27) {

					if(globalNav.elem.$pageHeader.classList.contains(globalNav.headerActiveClass)) {
						globalNav.toggleNav(e);
					}
				}
			});
		}
	}
};

export { globalNav };
